import { NavegacionProductos } from '../../components';

const FrijolesEnterosClaros = () => {
    return <NavegacionProductos />;
};

export default FrijolesEnterosClaros;
